/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React from "react";

export default React.createContext({
  _step: 1,
  setStep: (_step: number) => {},
});
